(function ($) {
    // modal music
    $(document).on('click', '.song__require',function(event){
        event.preventDefault();
        $('.modal-reg-package-music').modal('show');
    });

    // modal playlist
    $(document).on('click', '.playlist__require',function(){
        $('.modal-reg-package-music').modal('show');
    });
})(jQuery);
